<template>
    <div>
        <transition name="slide-fade">
            <div class="menu-bar" v-if="this.showAdminMenu">
                <!--        <Slide>-->
                <div class="top">
                    <div class="close_menu_btn" @click="onCloseMenuClick">Close menu</div>
<!--                    <div v-if="renderClass == 'desktop'">
                        <router-link v-if="userInfo.role == 'admin'" :to="{name: 'adminPanel'}"
                                     v-text="translate('adminPanel')"></router-link>
                    </div>-->
                    <div>
                        <router-link :to="{name: 'Places'}" @click.native="onMenuItemClick('Places')">{{translate('admin_Places')}}</router-link>
                        <router-link :to="{name: 'unlinkedQuestions'}" @click.native="onMenuItemClick('unlinkedQuestions')">{{translate('admin_UnQuestions')}}</router-link>
                        <router-link :to="{name: 'organization'}" @click.native="onMenuItemClick('organization')">{{translate('admin_Organizations')}}</router-link>
                        <router-link :to="{name: 'votes'}" @click.native="onMenuItemClick('votes')">{{translate('admin_Votes')}}</router-link>
                        <router-link :to="{name: 'profiles'}" @click.native="onMenuItemClick('profiles')">{{translate('admin_Profiles')}}</router-link>
                        <router-link :to="{name: 'userActions'}" @click.native="onMenuItemClick('userActions')">User actions</router-link>
                        <router-link :to="{name: 'closeAccountRequests'}" @click.native="onMenuItemClick('closeAccountRequests')">{{translate('admin_closeAccountRequests')}}</router-link>
                        <router-link :to="{name: 'landingQuestions'}" @click.native="onMenuItemClick('landingQuestions')">{{translate('admin_landingQuestions')}}</router-link>
                        <router-link :to="{name: 'shortLinks'}" @click.native="onMenuItemClick('shortLinks')">Shortlinks</router-link>
                        <router-link :to="{name: 'landingFiles'}" @click.native="onMenuItemClick('landingFiles')">LandingFiles</router-link>
                        <router-link :to="{name: 'serviceRequests'}"  @click.native="onMenuItemClick('serviceRequests')">ServiceRequests</router-link>
                        <router-link :to="{name: 'subscriptions'}" @click.native="onMenuItemClick('subscriptions')">Subscriptions</router-link>
                        <router-link :to="{name: 'locationIssues'}"  @click.native="onMenuItemClick('locationIssues')">Location Issues</router-link>
                        <router-link :to="{name: 'pdfGeneration'}" @click.native="onMenuItemClick('pdfGeneration')">PdfGeneration</router-link>
                    </div>
                    <span @click="onPlaceManagmentLinkClick">
                      <router-link
                              v-if="(isUserOwner && hasOwnOrganization) || (isUserOrgManager || isUserSiteManager)"
                              :to="{name: 'OwnerPlaceManagement', params: {analyticActiveBool: true}}"
                              v-text="translate('myBusiness')"
                      >
                      </router-link>
                    </span>
                    <router-link
                            v-if="(isUserOwner && hasOwnOrganization) || (isUserOrgManager || isUserSiteManager)"
                            :to="{name: 'ProfileSettings'}"
                            v-text="translate('ProfileSettings')"
                    >
                    </router-link>
                </div>
                <div class="bottom">
                    <div class="change_language absolute">
                        <languageSwitcher></languageSwitcher>
                    </div>
                    <a @click="logout()" v-text="translate('Logout')" class="logout"></a>
                </div>
                <!--        </Slide>-->
            </div>
        </transition>
    </div>
</template>

<script>
    import $ from 'jquery'

    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import logAnalyticsEvent from '@/helpers/analytics'
    import Places from "../admin/tabs/Places";
    //
    import languageSwitcher from '@/components/widgets/languageSwitcher'

    export default {
        name: 'menuBar',

        data(){
            return {
                showMenu: false,
                renderClass: 'desktop',
            }
        },

        components: {
            languageSwitcher,
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
            }),

            ...mapGetters({
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                hasOwnOrganization: 'auth/hasOwnOrganization',
                isUserSiteManager: 'auth/isUserSiteManager',
                showAdminMenu: 'auth/getShowAdminMenu',
            }),

        },

        mounted() {
            // $(document).on('mousedown', e => {
            //     if (this.showMenu) {
            //         if (($(".menu-bar").has(e.target).length === 0 &&
            //             e.target.className != 'menu-bar' ) ||
            //             e.target.className.indexOf('router-link') != -1){
            //             this.showMenu = false
            //         }
            //     }
            // });
            this.renderClass = window.innerWidth > 1000 ? 'desktop' : 'mobile'
        },

        methods: {

            ...mapActions({
                logoutRemote: 'auth/logout',
            }),
            ...mapMutations({
                removeKeys: 'auth/removeKeys'
            }),

            async logout() {
                logAnalyticsEvent('drawer_logout_click')
                try {
                    await this.logoutRemote()
                } catch (error) {
                    console.log('error', error)
                } finally {
                    this.removeKeys()
                    this.$store.commit('owner/setOwner', false)
                    this.$router.push('/sign-in')
                }
            },

            onListLinkClick() {
                logAnalyticsEvent('drawer_list_btn_click')
            },

            onPlaceManagmentLinkClick() {
                logAnalyticsEvent('drawer_owner_panel_btn_click')
            },
            onMenuItemClick(adminRouteName) {
                if(window.innerWidth < 800) {
                    this.toggleAdminMenu()
                }
                if(adminRouteName) {
                    localStorage.setItem('last_admin_route_name', adminRouteName)
                }
            },
            onCloseMenuClick() {
                this.toggleAdminMenu()
            },
            toggleAdminMenu(){
                this.$store.commit('auth/toggleAdminMenu')
            },


        },
    }
</script>

<style scoped>

    .slide-fade-enter-active {
        transition: all .1s ease;
    }
    .slide-fade-leave-active {
        transition: all .01s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(-10px);
        opacity: 0;
    }

    .menu-bar {
        height: 100vh;
        max-height: 100vh;
        overflow-x: hidden;
        background: #fff;
        position: relative;
        top: 0;
        left: 0;
        z-index: 999999;
        cursor: auto;
        width: 180px;
        max-width: 300px;
        border-right: 1px solid black;
    }
    .menu-bar {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .top {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        margin-top: 0px;
    }

    .top span {
        width: 100%;
        text-align: left;
    }

    .top a {
        display: inline-block;
        color: #2F2F2F;
        font-size: 16px;
        font-weight: 700;
        line-height: 16px;
        width: 100%;
        text-align: left;
        transition: all .3s ease-in-out;
        text-decoration: none;
        padding-bottom: 8px;
        padding-top: 8px;
        border-bottom: 1px solid #a4a4a4;
        padding-left: 12px;
        padding-right: 12px;
    }
    .top a:hover {
        color: #ffffff;
        background: #2b73de;
        text-decoration: none;
    }
    .top .router-link-active {
        color: #ffffff;
        background: #2b73de;
    }

    /*bottom section*/
    .bottom {
        position: relative;
        padding-top: 45px;
        margin-bottom: 20px;
    }

    .bottom:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        box-shadow: 0 0 1px 0 #2F2F2F;
        background: #2F2F2F;
    }

    .logout {
        /*width: 100%;*/
        position: absolute;
        right: 1em;
        bottom: 0;
        display: block;
        text-align: right;
        cursor: pointer;
    }

    .close_menu_btn {
        display: none;
        padding-top: 12px;
        padding-bottom: 12px;
        align-self: flex-end;
        padding-left: 12px;
        padding-right: 12px;
        cursor: pointer;
    }
    .close_menu_btn:hover {
        text-decoration: underline;
    }
    @media screen and (max-width: 800px) {
        .menu-bar {
            position: absolute;
        }
        .close_menu_btn {
            display: block;
        }
    }

</style>
